<template>
    <div class="setting-online-msg-voice">
        <div class="module-item-style">
            <div class="module-item-title">消息声音设置</div>
            <div class="module-item-tips">选择默认消息声音提醒，访客发送信息时，客服接收后将以设置声音提醒客服（设置对网页、客户端有效）。</div>
        </div>
		<div class="module-item-style">
			<div class="module-item-title">
				<div class="isSwitch">
					<span>访客上线声音提示</span>
					<el-switch
						v-model="onlineVoiceBtn"
						class="switch-btn"
						@change="saveChange('is_open_online_voice_remind',onlineVoiceBtn)"
						active-color="#68B974">
					</el-switch>
				</div>
				
			</div>
			<div class="module-item-tips">开启后，访客上线时客服可以听到上线声音，默认开启</div>
		</div>
		<div class="module-item-style">
			<div class="module-item-title">
				<div class="isSwitch">
					<span>访客下线声音提示</span>
					<el-switch
						v-model="offlineVoiceBtn"
						class="switch-btn"
						@change="saveChange('is_open_offline_voice_remind',offlineVoiceBtn)"
						active-color="#68B974">
					</el-switch>
				</div>
				
			</div>
			<div class="module-item-tips">开启后，访客下线时客服可以听到下线声音，默认开启</div>
		</div>
        <div class="module-item-style">
            <div class="module-item-title" style="padding-bottom: 10px;">系统声音</div>
            <div class="voice-list-container">
                <div class="voice-item-box" v-for="(item, index) in defaultVoiceList" :key="item.id">
                    <div class="radio-box">
                        <input type="radio" class="radio_type" :value="item.id" name="vocie" v-if="chosenVoiceId == item.id" checked>
                        <input type="radio" @click="setVoice(item.id,item.url)" class="radio_type" :value="item.id"
                               name="vocie" v-else>
                    </div>
                    <div class="voice-item">
                        <div class="voice-item-top">
                            <div class="voice-play-stop-btn">
                                <div v-if="voicePlayId == item.id">
                                    <svg-icon icon-class="audio-play" class="audio-btn" v-if="!voicePlaying" @click.native="voiceOperate(item.url,item.id)"></svg-icon>
                                    <svg-icon icon-class="audio-stop" class="audio-btn" v-else @click.native="voiceStop(item.id)"></svg-icon>
                                </div>
                                <div v-else>
                                    <svg-icon icon-class="audio-play" class="audio-btn" @click.native="voiceOperate(item.url,item.id)"></svg-icon>
                                </div>

                            </div>
                            <div class="voice-info">
                                <div class="voice-name">{{item.name}}</div>
                                <div class="voice-type">格式：{{getFile(item.musicName)}}</div>
                            </div>
                        </div>
                        <!--                    <div class="voice-item-footer">-->
                        <!--                        <span>00:00</span>-->
                        <!--                        <div class="progress-bar"></div>-->
                        <!--                        <span>01:00</span>-->
                        <!--                    </div>-->
                    </div>
                </div>
            </div>

        </div>

        <div class="module-item-style">
            <div class="module-item-title">自定义声音</div>
            <div class="module-item-tips"  style="line-height: 20px;padding: 10px 0;">
                <div>请上传MP3格式的音频文件，大小在5M以内。</div>
                <div>下面列表显示的名字即为上传的文件名。</div>
            </div>
            <input type="file" @change="voiceFileChange" v-show="false" ref="voiceFileInput">
            <span class="wl-btn" @click="uploadMp3File" v-loading="isLoading">上传</span>
            <div class="voice-list-container" style="padding-top: 15px;">
                <div class="voice-item-box custom-voice" v-for="(item, index) in customVoiceList" :key="item.id">
                    <i class="el-icon-circle-close delVoice" @click="delCustomVoice(item, item.id)"></i>
                    <div class="radio-box">
                        <input type="radio" class="radio_type" :value="item.id" name="vocie" v-if="chosenVoiceId == item.id" checked>
                        <input type="radio" @click="setVoice(item.id,item.url)" class="radio_type" :value="item.id"
                               name="vocie" v-else>
                    </div>
                    <div class="voice-item">
                        <div class="voice-item-top">
                            <div class="voice-play-stop-btn">
                                <div v-if="voicePlayId == item.id">
                                    <svg-icon icon-class="audio-play" class="audio-btn" v-if="!voicePlaying" @click.native="voiceOperate(item.url,item.id)"></svg-icon>
                                    <svg-icon icon-class="audio-stop" class="audio-btn" v-else @click.native="voiceStop(item.id)"></svg-icon>
                                </div>
                                <div v-else>
                                    <svg-icon icon-class="audio-play" class="audio-btn" @click.native="voiceOperate(item.url,item.id)"></svg-icon>
                                </div>

                            </div>
                            <div class="voice-info">
                                <div class="voice-name">{{item.name}}</div>
                                <div class="voice-type">格式：{{getFile(item.musicName)}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'setting-online-msg-voice',
        data() {
            return {
                defaultVoiceList:[],
                customVoiceList:[],
                chosenVoiceId:'',
                audio:null,
                voicePlaying: false,
                voicePlayId:'',
                isLoading: false,
				onlineVoiceBtn:true,
				offlineVoiceBtn:true,
            }
        },
        created() {
            this.getVoiceData()
			this.getBaseConfig()
        },
        mounted() {
            this.audio = new Audio()
        },
        beforeDestroy(){
            this.audio.pause();
            this.voicePlaying = false
            this.audio  = null
        },
        methods: {
            delCustomVoice(item, id){
                this.$confirm('正在进行删除操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.voiceStop(id)
                    this.$http.delCustomVoiceAPI({
                        msgMusicId:item.id
                    }).then( res => {
                        if(res.status == 1){
                            this.getVoiceData()
                            this.$message({
                                message:res.msg,
                                type: 'success'
                            })
                        }else {
                            this.$message({
                                message:res.msg,
                                type: 'error'
                            })
                        }
                    })
                }).catch(() => {

                });
            },
            uploadMp3File(){
                this.$refs.voiceFileInput.click()
            },
            voiceFileChange(e){
                let file = e.target.files[0]
                let formData = new FormData();
                formData.set("file",file)
                formData.set("name",file.name)
                this.isLoading = true
                this.$http.uploadVoiceAPI(formData).then( res => {
                    if(res.status == 1){
                        this.getVoiceData()
                        this.$message({
                            message:res.msg,
                            type: 'success'
                        })
                    }else {
                        this.$message({
                            message:res.msg,
                            type: 'error'
                        })
                    }
                    this.isLoading = false
                    this.$refs.voiceFileInput.value = ''
                }).catch( err => {
                    this.isLoading = false
                    this.$refs.voiceFileInput.value = ''
                })
            },
            getFile(str){
                return str.substring(str.length -3, str.length)
            },
            getVoiceData() {
                this.$http.getVoiceListAPI().then(res => {
                    if (res.status == 1) {
                        this.defaultVoiceList = res.defaultMusic
                        this.customVoiceList = res.customMusic
                        this.chosenVoiceId = res.chosenVoiceId.msg_music_id
                    }
                })
            },
            voiceOperate(url,id){
                if(this.audio){
                    this.audio.pause()
                }
                this.voicePlayId = id
                let _that = this
                this.$nextTick(() => {
                    // this.audio = new Audio();
                    this.audio.src = url;
                    this.audio.play();
                    this.voicePlaying = true
                    this.audio.addEventListener('ended',function () {
                        _that.voicePlaying = false
                    }, false);
                })

            },
            voiceStop(id){
              if(this.voicePlayId == id){
                  this.audio.pause();
                  this.voicePlaying = false
              }


            },
            setVoice(id,url){
                this.$http.saveConfigAPI({
                    name:'msg_music_id',
                    value:id
                }).then( res => {
                    if(res.status == 1){
                        this.getVoiceData()
                        this.$store.dispatch('user/changeMsgMusic',{
                            url: url
                        })
                        this.$message({
                            message:res.msg,
                            type: 'success'
                        })
                    }else {
                        this.$message({
                            message:res.msg,
                            type: 'error'
                        })
                    }
                })
            },
			getBaseConfig(){
				this.$http.getConfigAPI().then( res => {
					console.log(res)
				    if(res.status == 1){
				        if(res.data.is_open_online_voice_remind==0){
							this.onlineVoiceBtn = false
						}
						if(res.data.is_open_offline_voice_remind==0){
							this.offlineVoiceBtn = false
						}
				    }
				})
			},
			saveChange(name,value){
			  let postValue
			  if(value == 'true' || value == true){
			    postValue = 1
			  }else if (value == 'false' || value == false) {
			    postValue = 0
			  }
			  this.$http.saveConfigAPI({
			    name,
			    value:postValue
			  }).then( res => {
			    if(res.status == 1){
			      this.$message({
			        message: res.msg,
			        type: 'success',
			      })
			      this.getBaseConfig()
			    }else {
			      this.$message({
			        message: res.msg,
			        type: 'error',
			      })
			    }
			  })
			},
        }
    }
</script>

<style lang="scss">
    .setting-online-msg-voice {
        .voice-list-container {
            display: flex;
            flex-wrap: wrap;
            .voice-item-box{
                display: flex;
                align-items: center;
                width: 334px;
                margin-right: 50px;
                margin-bottom: 30px;
                .radio-box{
                    padding-right: 14px;
                }
                .radio_type{
                    width: 20px;
                    height: 20px;
                    appearance: none;
                    position: relative;
                    outline: none;
                    cursor: pointer;
                }
                .radio_type:before{
                    content: '';
                    width: 20px;
                    height: 20px;
                    border: 1px solid #7d7d7d;
                    display: inline-block;
                    border-radius: 50%;
                    vertical-align: middle;
                }
                .radio_type:checked:before{
                    content: '';
                    width: 20px;
                    height: 20px;
                    border: 1px solid $mainColor;
                    background:$mainColor;
                    display: inline-block;
                    border-radius: 50%;
                    vertical-align: middle;
                }
                .radio_type:checked:after{
                    content: '';
                    width: 10px;
                    height:5px;
                    border: 2px solid white;
                    border-top: transparent;
                    border-right: transparent;
                    text-align: center;
                    display: block;
                    position: absolute;
                    top: 6px;
                    left:5px;
                    vertical-align: middle;
                    transform: rotate(-45deg);
                }
                .radio_type:checked+label{
                    color: #c59c5a;
                }
                .voice-item {
                    padding: 21px;
                    width: 300px;
                    border: 1px solid #eee;
                    border-radius: $mainBorderRadius;

                    .voice-item-top {
                        display: flex;
                        align-items: center;

                        .audio-btn {
                            width: 54px;
                            height: 54px;
                            cursor: pointer;
                        }

                        .voice-info {
                            padding-left: 20px;

                            .voice-name {
                                font-size: 14px;
                                color: #333;
                                width: 165px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }

                            .voice-type {
                                font-size: 12px;
                                color: #999;
                                margin-top: 12px;
                            }
                        }
                    }

                    .voice-item-footer {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 34px;

                        .progress-bar {
                            width: 162px;
                            height: 16px;
                        }
                    }
                }

                &.custom-voice{
                    position: relative;
                    .delVoice{
                        position: absolute;
                        top: -5px;
                        right: -5px;
                        z-index: 2;
                        font-size: 20px;
                        color: #666;
                        background-color: #fff;
                        cursor: pointer;
                    }
                }
            }

        }
    }
	.isSwitch {
	    display: flex;
	
	    .switch-btn {
	        margin-left: auto;
	    }
	}
</style>
